import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo0.png'


const _withScopeId = n => (_pushScopeId("data-v-11640640"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "",
  style: {"width":"70px","height":"70px"}
}, null, -1))
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "309px",
  height: "26px"
}
const _hoisted_4 = {
  kerning: "auto",
  "font-family": "Adobe Heiti Std",
  fill: "rgb(0, 0, 0)",
  "font-size": "26px",
  x: "0px",
  y: "21.953px"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "首页", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "产品中心", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "产品方案", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "行业动态", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "项目案例", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "荣誉资质", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "关于我们", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage('/', '首页'))),
      class: "logo-info"
    }, [
      _hoisted_2,
      (_openBlock(), _createElementBlock("svg", _hoisted_3, [
        _createElementVNode("text", _hoisted_4, [
          _createElementVNode("tspan", {
            "font-size": "26px",
            "font-family": "Microsoft YaHei",
            "font-weight": "bold",
            fill: _ctx.state.isHomeFirst ? '#fff' : '#333'
          }, " 四川润泽皓宇科技有限公司 ", 8, _hoisted_5)
        ])
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["menu-list", _ctx.state.isHomeFirst ? 'first' : ''])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item", _ctx.state.currentActiveMenu === '首页' ? 'active' : '']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage('/', '首页')))
      }, _hoisted_8, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item", _ctx.state.currentActiveMenu === '产品中心' ? 'active' : '']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage('/product', '产品中心')))
      }, _hoisted_11, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item", _ctx.state.currentActiveMenu === '产品方案' ? 'active' : '']),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage('/scheme', '产品方案')))
      }, _hoisted_14, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item", _ctx.state.currentActiveMenu === '行业动态' ? 'active' : '']),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage('/news', '行业动态')))
      }, _hoisted_17, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item", _ctx.state.currentActiveMenu === '项目案例' ? 'active' : '']),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPage('/detail?id=38', '项目案例')))
      }, _hoisted_20, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item", _ctx.state.currentActiveMenu === '荣誉资质' ? 'active' : '']),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToPage('/cert', '荣誉资质')))
      }, _hoisted_23, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item", _ctx.state.currentActiveMenu === '关于我们' ? 'active' : '']),
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage('/about', '关于我们')))
      }, _hoisted_26, 2)
    ], 2)
  ]))
}